import styled from 'styled-components';
import { TabMenu } from '@everlywell/leaves';

export const StyledTabMenu = styled(TabMenu)`
  ul {
    justify-content: flex-start;
    gap: 20%;
  }
`;
